<template>
  <b-modal :id="modalId" centered title="Attendance Detail" @hide="$emit('close')" hide-header-close hide-footer>
    <b-row v-if="data" class="d-flex flex-column gap-5">
      <b-row>
        <h3>Participant Detail</h3>
        <b-row class="d-flex flex-row justify-content-between align-items-center">
          <b-col class="d-flex flex-column gap-1 col-6">
            <label>Name</label>
            <h4>{{ data?.employee?.name }}</h4>
          </b-col>

          <b-col class="d-flex flex-column gap-1 col-6">
            <label>Email</label>
            <h4>{{ data?.employee?.email }}</h4>
          </b-col>
        </b-row>
        <b-row class="d-flex flex-row justify-content-between align-items-center">
          <b-col class="d-flex flex-column gap-1 col-6">
            <label>Department</label>
            <h4>{{ data?.employee?.department }}</h4>
          </b-col>

          <b-col class="d-flex flex-column gap-1 col-6">
            <label>Division</label>
            <h4>{{ data?.employee?.division }}</h4>
          </b-col>
        </b-row>
        <b-row class="d-flex flex-row justify-content-between align-items-center">
          <b-col class="d-flex flex-column gap-1 col-6">
            <label>Position</label>
            <h4>{{ data?.employee?.position }}</h4>
          </b-col>
        </b-row>
      </b-row>
      <b-row>
        <h3>Training Detail</h3>
        <b-row class="d-flex flex-row justify-content-between align-items-center">
          <b-col class="d-flex flex-column gap-1 col-6">
            <label>Training Title</label>
            <h4>{{ data?.training }}</h4>
          </b-col>

          <b-col class="d-flex flex-column gap-1 col-6">
            <label>Attendance Date</label>
            <h4>{{ formatAttendance(data?.attendance_at) }}</h4>
          </b-col>
        </b-row>
      </b-row>
    </b-row>
  </b-modal>
</template>

<script>
import { formatDate, formatTimeToHHMM } from "../utils/utils";

export default {
  name: "AttendanceModal",
  props: {
    data: { type: Object, default: null },
    modalId: { type: String, default: "attendance-modal" },
  },

  methods: {
    formatDate,
    formatTimeToHHMM,
    formatAttendance(dateIso) {
      if (!dateIso) return "-";

      try {
        const d = new Date(dateIso);
        const wibTs = d.getTime() + 7 * 60 * 60 * 1000;
        const dWib = new Date(wibTs);

        const hh = String(dWib.getUTCHours()).padStart(2, "0");
        const mm = String(dWib.getUTCMinutes()).padStart(2, "0");
        const ss = String(dWib.getUTCSeconds()).padStart(2, "0");

        const timeWithOffset = `${hh}:${mm}:${ss}+07`;

        return `${this.formatDate(dateIso)} - ${this.formatTimeToHHMM(timeWithOffset)}`;
      } catch (e) {
        return this.formatDate(dateIso);
      }
    },
  },
};
</script>

<style scoped>
.gap-2 > * + * {
  margin-left: 0.5rem;
}

.table td {
  padding: 0.5rem 0;
}

.d-flex.flex-wrap {
  row-gap: 0.25rem;
  column-gap: 0.25rem;
}

.completion-badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}
</style>
